import { PlusSquareIcon } from '@phosphor-icons/react';
import { FC } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'sonner';

import { Button } from '@/components/ui/button';
import { ItemStatusEnum } from '@/modules/common';
import {
  PageHeader,
  Spinner,
  useApiMutation,
  useApiQuery,
} from '@/modules/common';
import { Routes } from '@/router/routes';

import { OverlaysTable } from '../components';
import { OverlayItem } from '../types';

export const OverlaysPage: FC = () => {
  const navigate = useNavigate();

  const { isFetching, data, refetch } = useApiQuery<OverlayItem[]>(
    '/overlays',
    {
      queryKey: ['overlays'],
      initialData: [],
    }
  );

  const updateOverlayMutation = useApiMutation<OverlayItem>(
    '/overlays',
    {
      method: 'PATCH',
    },
    {
      onError: () => {
        toast.error('Uh oh! Something went wrong.');
      },
    }
  );

  const toggleOverlayStatus = async (style: OverlayItem) => {
    await updateOverlayMutation.mutateAsync({
      ...style,
      status:
        style.status === ItemStatusEnum.Archived
          ? ItemStatusEnum.Ready
          : ItemStatusEnum.Archived,
    });
    return await refetch();
  };

  const redirectToOverlayDetails = (item) => {
    navigate(Routes.OverlayDetails.replace(':id', item.id));
  };

  return (
    <div>
      <PageHeader
        title="Overlays"
        actions={[
          <Link
            to={Routes.NewOverlay}
            key="new-overlay"
            data-testid="add-new-overlay-link"
          >
            <Button disabled={isFetching} data-testid="add-new-model-button">
              <PlusSquareIcon />
              Add new overlay
            </Button>
          </Link>,
        ]}
      />

      {isFetching ? (
        <Spinner />
      ) : (
        <OverlaysTable
          data={data}
          toggleStatus={toggleOverlayStatus}
          onClick={redirectToOverlayDetails}
        />
      )}
    </div>
  );
};
